// src/index.tsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/css/v3.css';
// Mantine styles — core first, then spotlight (after other global CSS for cascade control)
import '@mantine/core/styles.css';
import '@mantine/spotlight/styles.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import reportWebVitals from './reportWebVitals';


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  
    <React.StrictMode>
      <AuthProvider>
        <App />
      </AuthProvider>
    </React.StrictMode>

);

reportWebVitals(console.log);